export const Permissions = {
	admin: {
		// disallowedProperties: [],
		privilegedSearch: true
	},
	gov_user: {
		// disallowedProperties: [],
		privilegedSearch: true
	},
	user: {
		// disallowedProperties: ['business_size', 'annual_revenue'],
		privilegedSearch: false
	},
	guest: {
		// disallowedProperties: ['business_size', 'annual_revenue'],
		privilegedSearch: false
	}
}